import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-md-6 col-12'>
						<span className='fw-light'>
							© {new Date().getFullYear()} Neel's Purchase. All rights reserved.
						</span>
					</div>
					{/* <div className='col-md-6 col-12 text-md-end'>
						<a
							href='/'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>Developed By <a href='https://octowebinfotech.com/'>OCTOWEB INFOTECH</a></small>
						</a>
					</div> */}
					<div className='col-md-6 col-12 text-md-end'>
						<a
							href='/'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>
								Developed By{' '}
								<span
									className='text-primary text-decoration-underline'
									style={{ cursor: 'pointer' }}
									onClick={(e) => {
										e.stopPropagation(); // 🚫 stop click from bubbling up
										e.preventDefault(); // 🚫 prevent parent <a> navigation
										window.open('https://octowebinfotech.com/', '_blank');
									}}>
									OCTOWEB INFOTECH
								</span>
							</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
